import { observer } from "mobx-react-lite";
import { useRootStore } from "../../stores/hooks";
import { SpinnerStyle } from "./style";

export const Spinner = observer(() => {
  const { automations } = useRootStore();

  return automations.loadingDynamicDescription ? <SpinnerStyle /> : null;
});
